/**
 * Custom Tooltip Component
 * @perfectserve/library package
 * Provides a styled tooltip similar to the Speed to Care tooltip
 */
import React, { useEffect, useRef, useState } from "react";
var Tooltip = function (_a) {
    var content = _a.content, children = _a.children, _b = _a.position, position = _b === void 0 ? "top" : _b, _c = _a.maxWidth, maxWidth = _c === void 0 ? "300px" : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var _f = useState(false), isVisible = _f[0], setIsVisible = _f[1];
    var _g = useState({ top: 0, left: 0 }), tooltipPosition = _g[0], setTooltipPosition = _g[1];
    var triggerRef = useRef(null);
    var tooltipRef = useRef(null);
    var showTooltip = function () {
        if (disabled)
            return;
        setIsVisible(true);
    };
    var hideTooltip = function () {
        setIsVisible(false);
    };
    useEffect(function () {
        if (isVisible && triggerRef.current && tooltipRef.current) {
            var triggerRect = triggerRef.current.getBoundingClientRect();
            var tooltipRect = tooltipRef.current.getBoundingClientRect();
            var viewportWidth = window.innerWidth;
            var viewportHeight = window.innerHeight;
            var top_1 = 0;
            var left = 0;
            switch (position) {
                case "top":
                    top_1 = triggerRect.top - tooltipRect.height - 8;
                    left = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
                    break;
                case "bottom":
                    top_1 = triggerRect.bottom + 8;
                    left = triggerRect.left + (triggerRect.width - tooltipRect.width) / 2;
                    break;
                case "left":
                    top_1 = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
                    left = triggerRect.left - tooltipRect.width - 8;
                    break;
                case "right":
                    top_1 = triggerRect.top + (triggerRect.height - tooltipRect.height) / 2;
                    left = triggerRect.right + 8;
                    break;
            }
            // Adjust for viewport boundaries
            if (left < 8)
                left = 8;
            if (left + tooltipRect.width > viewportWidth - 8) {
                left = viewportWidth - tooltipRect.width - 8;
            }
            if (top_1 < 8)
                top_1 = 8;
            if (top_1 + tooltipRect.height > viewportHeight - 8) {
                top_1 = viewportHeight - tooltipRect.height - 8;
            }
            setTooltipPosition({ top: top_1, left: left });
        }
    }, [isVisible, position]);
    if (disabled) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: triggerRef, onMouseEnter: showTooltip, onMouseLeave: hideTooltip, onFocus: showTooltip, onBlur: hideTooltip, className: className, style: { display: "inline-block" } }, children),
        isVisible && (React.createElement("div", { ref: tooltipRef, style: {
                position: "fixed",
                top: tooltipPosition.top,
                left: tooltipPosition.left,
                zIndex: 10000,
                maxWidth: maxWidth,
                backgroundColor: "white",
                color: "#333",
                padding: "12px 16px",
                borderRadius: "8px",
                fontSize: "13px",
                lineHeight: "1.4",
                fontFamily: "var(--lib-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)",
                border: "1px solid #e1e5e9",
                pointerEvents: "none",
                whiteSpace: "pre-line",
            } }, content))));
};
export default Tooltip;
